/*** IMPORTS FROM imports-loader ***/
var _ = require("lodash");

import * as types from './mutations-types'
import * as util from 'assets/js/util'

const mutations = {
  // Vuex 中的 mutation 非常类似于事件：
  // 每个 mutation 都有一个字符串的 事件类型 (type) 和 一个 回调函数 (handler)。
  // 这个回调函数就是我们实际进行状态更改的地方，并且它会接受 state 作为第一个参数

  [types.SET_COURSE](state, course) {
    state.course = course
  },
  // 返回上一步文件
  [types.SET_BACKGOFILE](state, file) {
    console.log(state, file, '------------------')
    state.backgoFile = file
  },
  // 记录用户信息
  [types.RECORD_USERINFO](state, info) {
    var userInfo = Object.assign({}, state.userInfo, info)
    state.userInfo = JSON.parse(JSON.stringify(userInfo))
    util.cookieOperate.setUserInfo(JSON.parse(JSON.stringify(userInfo)))
  },
  // 更新用户AuthorToken
  [types.UPDATE_AUTHORTOKEN](state, val) {
    util.cookieOperate.setAuthorToken(val)
    state.authorToken = val
  },
  // 清除用户AuthorToken
  [types.REMOVE_AUTHORTOKEN](state) {
    util.cookieOperate.removeAuthorToken()
    state.authorToken = ''
  },
  // 更新用户OrderVTime
  [types.UPDATE_ORDERVTIME](state, val) {
    util.cookieOperate.setOrderVTime(JSON.parse(JSON.stringify(val)))
    state.orderVTime = JSON.parse(JSON.stringify(val))
  },
  // 清除用户OrderVTime
  [types.REMOVE_ORDERVTIME](state) {
    util.cookieOperate.removeOrderVTime()
    state.orderVTime = ''
  },
  // 更新用户OrderInfo
  [types.UPDATE_ORDERINFO](state, val) {
    console.log(state, val, 'vvvvvvvvvvvvvvvvvvvvvv更新用户OrderInfo')
    util.cookieOperate.setOrderInfo(JSON.parse(JSON.stringify(val)))
    state.orderInfo = JSON.parse(JSON.stringify(val))
  },
  // 清除用户OrderInfo
  [types.REMOVE_ORDERINFO](state) {
    util.cookieOperate.removeOrderInfo()
    state.orderInfo = ''
  },
  // 更新用户OrderInquireState
  [types.UPDATE_ORDERINQUIRESTATE](state, val) {
    util.cookieOperate.setOrderInquireState(JSON.parse(JSON.stringify(val)))
    state.orderInquireState = JSON.parse(JSON.stringify(val))
  },
  // 清除用户OrderInquireState
  [types.REMOVE_ORDERINQUIRESTATE](state) {
    util.cookieOperate.removeOrderInquireState()
    state.orderInquireState = ''
  },
  // 清除用户信息
  [types.REMOVE_USEINFO](state) {
    util.cookieOperate.removeUserInfo()
    state.userInfo = null
  },
  // 记录进入登录流程之前的页面路径
  [types.UPDATE_BEFORELOGINPAGE](state, val) {
    util.cookieOperate.setBeforeLoginPage(val)
    state.beforeLoginPage = val
  },
  // 记录登录第三方平台名称
  [types.RECORD_THIRDPARTY](state, val) {
    state.thirdParty = val
  },
  // 记录登录第三方平台信息
  [types.RECORD_THIRDPARTYINFO](state, val) {
    state.thirdPartyInfo[state.thirdParty] = val
  },
  // 记录进入登录流程之前的页面路径 待废除
  [types.SET_BEFORELOGINPAGE](state, val) {
    state.beforeLoginPage = val
  },
  // 记录系统信息
  [types.RECORD_SYSTEMINFO](state) {
    state.systemInfo = util.browser
  },
  // 广告已经加载
  [types.SET_BANNERSTATE](state, val) {
    util.cookieOperate.setBannerState(val)
    state.bannerState = val
  }
}

export default mutations




// WEBPACK FOOTER //
// ./src/store/mutations.js